/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * ScaleFi Nub APIs
 * Scale Fi Apis
 * OpenAPI spec version: v0.0.1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  BulkNotificationRequest,
  CustomerNotificationHistory,
  CustomerNotificationResponse,
  GeneralMeetingRequest,
  GetNotificationHistoryParams,
  GetNotificationStatisticsParams,
  LoanReminderRequest,
  NotificationStatistics,
  PageCustomerNotificationHistory,
  ProductChangeRequest,
  PromotionalNotificationRequest,
  SendBulkNotifications200,
  SendGeneralMeetingNotifications1200,
  SendNotificationBody,
  SendProductChangeNotifications1200,
  SendPromotionalNotifications1200,
  TriggerLoanReminders1200
} from '../model';

import { customInstance } from '../mutator/custom-instance';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const sendNotification = (
    sendNotificationBody: SendNotificationBody,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CustomerNotificationResponse>(
      {url: `/api/v1/customer-notifications/send`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: sendNotificationBody, signal
    },
      options);
    }
  


export const getSendNotificationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendNotification>>, TError,{data: SendNotificationBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof sendNotification>>, TError,{data: SendNotificationBody}, TContext> => {

const mutationKey = ['sendNotification'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendNotification>>, {data: SendNotificationBody}> = (props) => {
          const {data} = props ?? {};

          return  sendNotification(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SendNotificationMutationResult = NonNullable<Awaited<ReturnType<typeof sendNotification>>>
    export type SendNotificationMutationBody = SendNotificationBody
    export type SendNotificationMutationError = unknown

    export const useSendNotification = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendNotification>>, TError,{data: SendNotificationBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sendNotification>>,
        TError,
        {data: SendNotificationBody},
        TContext
      > => {

      const mutationOptions = getSendNotificationMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const sendBulkNotifications = (
    bulkNotificationRequest: BulkNotificationRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<SendBulkNotifications200>(
      {url: `/api/v1/customer-notifications/send-bulk`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: bulkNotificationRequest, signal
    },
      options);
    }
  


export const getSendBulkNotificationsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendBulkNotifications>>, TError,{data: BulkNotificationRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof sendBulkNotifications>>, TError,{data: BulkNotificationRequest}, TContext> => {

const mutationKey = ['sendBulkNotifications'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendBulkNotifications>>, {data: BulkNotificationRequest}> = (props) => {
          const {data} = props ?? {};

          return  sendBulkNotifications(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SendBulkNotificationsMutationResult = NonNullable<Awaited<ReturnType<typeof sendBulkNotifications>>>
    export type SendBulkNotificationsMutationBody = BulkNotificationRequest
    export type SendBulkNotificationsMutationError = unknown

    export const useSendBulkNotifications = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendBulkNotifications>>, TError,{data: BulkNotificationRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sendBulkNotifications>>,
        TError,
        {data: BulkNotificationRequest},
        TContext
      > => {

      const mutationOptions = getSendBulkNotificationsMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const sendPromotionalNotifications1 = (
    promotionalNotificationRequest: PromotionalNotificationRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<SendPromotionalNotifications1200>(
      {url: `/api/v1/customer-notifications/promotional`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: promotionalNotificationRequest, signal
    },
      options);
    }
  


export const getSendPromotionalNotifications1MutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendPromotionalNotifications1>>, TError,{data: PromotionalNotificationRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof sendPromotionalNotifications1>>, TError,{data: PromotionalNotificationRequest}, TContext> => {

const mutationKey = ['sendPromotionalNotifications1'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendPromotionalNotifications1>>, {data: PromotionalNotificationRequest}> = (props) => {
          const {data} = props ?? {};

          return  sendPromotionalNotifications1(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SendPromotionalNotifications1MutationResult = NonNullable<Awaited<ReturnType<typeof sendPromotionalNotifications1>>>
    export type SendPromotionalNotifications1MutationBody = PromotionalNotificationRequest
    export type SendPromotionalNotifications1MutationError = unknown

    export const useSendPromotionalNotifications1 = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendPromotionalNotifications1>>, TError,{data: PromotionalNotificationRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sendPromotionalNotifications1>>,
        TError,
        {data: PromotionalNotificationRequest},
        TContext
      > => {

      const mutationOptions = getSendPromotionalNotifications1MutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const sendProductChangeNotifications1 = (
    productChangeRequest: ProductChangeRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<SendProductChangeNotifications1200>(
      {url: `/api/v1/customer-notifications/product-change`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: productChangeRequest, signal
    },
      options);
    }
  


export const getSendProductChangeNotifications1MutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendProductChangeNotifications1>>, TError,{data: ProductChangeRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof sendProductChangeNotifications1>>, TError,{data: ProductChangeRequest}, TContext> => {

const mutationKey = ['sendProductChangeNotifications1'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendProductChangeNotifications1>>, {data: ProductChangeRequest}> = (props) => {
          const {data} = props ?? {};

          return  sendProductChangeNotifications1(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SendProductChangeNotifications1MutationResult = NonNullable<Awaited<ReturnType<typeof sendProductChangeNotifications1>>>
    export type SendProductChangeNotifications1MutationBody = ProductChangeRequest
    export type SendProductChangeNotifications1MutationError = unknown

    export const useSendProductChangeNotifications1 = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendProductChangeNotifications1>>, TError,{data: ProductChangeRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sendProductChangeNotifications1>>,
        TError,
        {data: ProductChangeRequest},
        TContext
      > => {

      const mutationOptions = getSendProductChangeNotifications1MutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const triggerLoanReminders1 = (
    loanReminderRequest: LoanReminderRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<TriggerLoanReminders1200>(
      {url: `/api/v1/customer-notifications/loan-reminders`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: loanReminderRequest, signal
    },
      options);
    }
  


export const getTriggerLoanReminders1MutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof triggerLoanReminders1>>, TError,{data: LoanReminderRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof triggerLoanReminders1>>, TError,{data: LoanReminderRequest}, TContext> => {

const mutationKey = ['triggerLoanReminders1'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof triggerLoanReminders1>>, {data: LoanReminderRequest}> = (props) => {
          const {data} = props ?? {};

          return  triggerLoanReminders1(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TriggerLoanReminders1MutationResult = NonNullable<Awaited<ReturnType<typeof triggerLoanReminders1>>>
    export type TriggerLoanReminders1MutationBody = LoanReminderRequest
    export type TriggerLoanReminders1MutationError = unknown

    export const useTriggerLoanReminders1 = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof triggerLoanReminders1>>, TError,{data: LoanReminderRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof triggerLoanReminders1>>,
        TError,
        {data: LoanReminderRequest},
        TContext
      > => {

      const mutationOptions = getTriggerLoanReminders1MutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const sendGeneralMeetingNotifications1 = (
    generalMeetingRequest: GeneralMeetingRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<SendGeneralMeetingNotifications1200>(
      {url: `/api/v1/customer-notifications/general-meeting`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: generalMeetingRequest, signal
    },
      options);
    }
  


export const getSendGeneralMeetingNotifications1MutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendGeneralMeetingNotifications1>>, TError,{data: GeneralMeetingRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof sendGeneralMeetingNotifications1>>, TError,{data: GeneralMeetingRequest}, TContext> => {

const mutationKey = ['sendGeneralMeetingNotifications1'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendGeneralMeetingNotifications1>>, {data: GeneralMeetingRequest}> = (props) => {
          const {data} = props ?? {};

          return  sendGeneralMeetingNotifications1(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SendGeneralMeetingNotifications1MutationResult = NonNullable<Awaited<ReturnType<typeof sendGeneralMeetingNotifications1>>>
    export type SendGeneralMeetingNotifications1MutationBody = GeneralMeetingRequest
    export type SendGeneralMeetingNotifications1MutationError = unknown

    export const useSendGeneralMeetingNotifications1 = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendGeneralMeetingNotifications1>>, TError,{data: GeneralMeetingRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sendGeneralMeetingNotifications1>>,
        TError,
        {data: GeneralMeetingRequest},
        TContext
      > => {

      const mutationOptions = getSendGeneralMeetingNotifications1MutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const getNotificationStatistics = (
    params?: GetNotificationStatisticsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<NotificationStatistics>(
      {url: `/api/v1/customer-notifications/statistics`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetNotificationStatisticsQueryKey = (params?: GetNotificationStatisticsParams,) => {
    return [`/api/v1/customer-notifications/statistics`, ...(params ? [params]: [])] as const;
    }

    
export const getGetNotificationStatisticsQueryOptions = <TData = Awaited<ReturnType<typeof getNotificationStatistics>>, TError = unknown>(params?: GetNotificationStatisticsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotificationStatistics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNotificationStatisticsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNotificationStatistics>>> = ({ signal }) => getNotificationStatistics(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNotificationStatistics>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetNotificationStatisticsQueryResult = NonNullable<Awaited<ReturnType<typeof getNotificationStatistics>>>
export type GetNotificationStatisticsQueryError = unknown


export function useGetNotificationStatistics<TData = Awaited<ReturnType<typeof getNotificationStatistics>>, TError = unknown>(
 params: undefined |  GetNotificationStatisticsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotificationStatistics>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNotificationStatistics>>,
          TError,
          Awaited<ReturnType<typeof getNotificationStatistics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetNotificationStatistics<TData = Awaited<ReturnType<typeof getNotificationStatistics>>, TError = unknown>(
 params?: GetNotificationStatisticsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotificationStatistics>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNotificationStatistics>>,
          TError,
          Awaited<ReturnType<typeof getNotificationStatistics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetNotificationStatistics<TData = Awaited<ReturnType<typeof getNotificationStatistics>>, TError = unknown>(
 params?: GetNotificationStatisticsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotificationStatistics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetNotificationStatistics<TData = Awaited<ReturnType<typeof getNotificationStatistics>>, TError = unknown>(
 params?: GetNotificationStatisticsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotificationStatistics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetNotificationStatisticsQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getNotificationHistory = (
    params: GetNotificationHistoryParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PageCustomerNotificationHistory>(
      {url: `/api/v1/customer-notifications/history`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetNotificationHistoryQueryKey = (params?: GetNotificationHistoryParams,) => {
    return [`/api/v1/customer-notifications/history`, ...(params ? [params]: [])] as const;
    }

    
export const getGetNotificationHistoryQueryOptions = <TData = Awaited<ReturnType<typeof getNotificationHistory>>, TError = unknown>(params: GetNotificationHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotificationHistory>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNotificationHistoryQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNotificationHistory>>> = ({ signal }) => getNotificationHistory(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNotificationHistory>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetNotificationHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof getNotificationHistory>>>
export type GetNotificationHistoryQueryError = unknown


export function useGetNotificationHistory<TData = Awaited<ReturnType<typeof getNotificationHistory>>, TError = unknown>(
 params: GetNotificationHistoryParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotificationHistory>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNotificationHistory>>,
          TError,
          Awaited<ReturnType<typeof getNotificationHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetNotificationHistory<TData = Awaited<ReturnType<typeof getNotificationHistory>>, TError = unknown>(
 params: GetNotificationHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotificationHistory>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNotificationHistory>>,
          TError,
          Awaited<ReturnType<typeof getNotificationHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetNotificationHistory<TData = Awaited<ReturnType<typeof getNotificationHistory>>, TError = unknown>(
 params: GetNotificationHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotificationHistory>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetNotificationHistory<TData = Awaited<ReturnType<typeof getNotificationHistory>>, TError = unknown>(
 params: GetNotificationHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotificationHistory>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetNotificationHistoryQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCustomerNotificationHistory = (
    branch: string,
    customerNumber: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CustomerNotificationHistory[]>(
      {url: `/api/v1/customer-notifications/history/${branch}/${customerNumber}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetCustomerNotificationHistoryQueryKey = (branch?: string,
    customerNumber?: string,) => {
    return [`/api/v1/customer-notifications/history/${branch}/${customerNumber}`] as const;
    }

    
export const getGetCustomerNotificationHistoryQueryOptions = <TData = Awaited<ReturnType<typeof getCustomerNotificationHistory>>, TError = unknown>(branch: string,
    customerNumber: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerNotificationHistory>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomerNotificationHistoryQueryKey(branch,customerNumber);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomerNotificationHistory>>> = ({ signal }) => getCustomerNotificationHistory(branch,customerNumber, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(branch && customerNumber), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCustomerNotificationHistory>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetCustomerNotificationHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomerNotificationHistory>>>
export type GetCustomerNotificationHistoryQueryError = unknown


export function useGetCustomerNotificationHistory<TData = Awaited<ReturnType<typeof getCustomerNotificationHistory>>, TError = unknown>(
 branch: string,
    customerNumber: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerNotificationHistory>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerNotificationHistory>>,
          TError,
          Awaited<ReturnType<typeof getCustomerNotificationHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCustomerNotificationHistory<TData = Awaited<ReturnType<typeof getCustomerNotificationHistory>>, TError = unknown>(
 branch: string,
    customerNumber: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerNotificationHistory>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerNotificationHistory>>,
          TError,
          Awaited<ReturnType<typeof getCustomerNotificationHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCustomerNotificationHistory<TData = Awaited<ReturnType<typeof getCustomerNotificationHistory>>, TError = unknown>(
 branch: string,
    customerNumber: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerNotificationHistory>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetCustomerNotificationHistory<TData = Awaited<ReturnType<typeof getCustomerNotificationHistory>>, TError = unknown>(
 branch: string,
    customerNumber: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerNotificationHistory>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetCustomerNotificationHistoryQueryOptions(branch,customerNumber,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



